<template>
  <div>
    <div class="ep-footer--line">
      <!-- **first line with links** -->
      <!-- left part*-->
      <ul class="ep-footer--line--list">
        <!-- link to homepage -->
        <li class="ep-footer--line--list--item">
          <router-link  @click.native="scrollToTop"
                        class="ep-footer--link" :to="{ name: 'HomePage'}">
            {{ $t('footer.list.welcome') }}
          </router-link>
        </li>
        <!-- link to security page -->
        <li class="ep-footer--line--list--item">
          <router-link  @click.native="scrollToTop"
                        class="ep-footer--link" :to="{ name: 'Security'}">
            {{ $t('footer.list.security') }}
          </router-link>
        </li>
        <!-- link to prices page -->
        <li class="ep-footer--line--list--item ep-footer--link">
          <router-link  @click.native="scrollToTop"
                        class="ep-footer--link" :to="{ name: 'Prices'}">
            {{ $t('footer.list.prices') }}
          </router-link>
        </li>
      </ul>
      <!-- right part* -->
      <ul class="ep-footer--line--list">

      <!-- certification link -->
        <li class="ep-footer--line--list--item">
          <a href="https://www.edoc.fr/edocgroup-presentation-societe/nos-partenaires/" target="_blank" class="ep-footer--link">
            {{ $t('footer.list.certification') }}
          </a>
        </li>
        <!-- cgpu-->
        <li class="ep-footer--line--list--item">
          <a href="https://support-edocperso.zendesk.com/hc/fr/articles/19966683438226-Conditions-g%C3%A9n%C3%A9rales-d-utilisation-et-de-vente-de-l-application-eDocPerso" target="_blank" class="ep-footer--link">
            {{ $t('footer.list.cgpu') }}
          </a>
        </li>

        <!-- About link -->
        <li class="ep-footer--line--list--item">
          <a href="https://www.edoc.fr/qui-sommes-nous/" target="_blank" class="ep-footer--link">
            {{ $t('footer.list.about') }}
          </a>
        </li>
      </ul>
    </div>
    <!-- **second line with logo, text and social networks button** -->
    <div class="ep-footer--line">
      <div class="ep-footer--line--termes">
        <h2 class="ep-footer--title">
          <router-link  @click.native="scrollToTop"
                      class="ep-footer--link ep-footer--link--noborder" :to="{ name: 'HomePage'}">
            <img src='../assets/img/logo.png' class="ep-footer--line--logo" />
          </router-link>
        </h2>
        <!-- *text* -->
        <p class="ep-footer--line--text">
          <a class="ep-footer--link ep-footer--link__orange">
            {{ $t('footer.text.link') }}
          </a>
          {{ $t('footer.text') }}
        </p>

              <!-- *social network logo and links* -->
        <div class="ep-footer--line--network">
          <!-- twitter -->
          <a class="ep-footer--line--network--content icon-twitter" href="https://twitter.com/SilaeSolutions" target="_blank"></a>
          <!-- linkedIn-->
          <a class="ep-footer--line--network--content" href="https://www.linkedin.com/company/silae/mycompany/" target="_blank">in</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import i18n from '../i18n';

export default {
  name: 'footer',
  methods: {
    i18n() {
      return i18n;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/footer.vue